import { nanoid } from "nanoid"
import { useEffect } from "react"
import Cookie from "js-cookie"

import { isBrowser } from "utils/infrastructure/ssg-utils"
import { SentryWrapper } from "utils/ThirdParty/Sentry/SentryWrapper"
import { IS_DEVELOPMENT } from "utils/env-management"
import { gaGetClientIdSync } from "utils/analytics"
import { growthBook } from "utils/infrastructure/growthBook/growthBook"

export function useGrowthBook() {
    useEffect(() => {
        if (!isBrowser()) return
        const GROWTH_BOOK_USER_ID = "growth_book_user_id"

        function catchError(err: unknown) {
            SentryWrapper.getInstance().captureException("GrowthBook error", { extra: { err } })
        }

        growthBook.loadFeatures().catch(catchError)

        let id = IS_DEVELOPMENT ? Cookie.get(GROWTH_BOOK_USER_ID) : gaGetClientIdSync()
        if (!id) {
            id = nanoid()
            Cookie.set(GROWTH_BOOK_USER_ID, id)
        }
        growthBook
            .setAttributes({
                id,
            })
            .catch(catchError)
    }, [])
}
